import React from 'react';
import PropTypes from 'prop-types';

const CustomLayoutContext = React.createContext(undefined);

const CustomLayoutProvider = ({ children }) => {
  const [visitedTabMap, setVisitedTabMap] = React.useState({});

  const handleVisitTab = React.useCallback((tabName) => {
    setVisitedTabMap(prev => ({ ...prev, [tabName]: true }));
  }, []);

  const hasTabBeenVisited = React.useCallback((tabName) => {
    return visitedTabMap[tabName] === true;
  }, [visitedTabMap]);

  const memoizedValue = React.useMemo(() => {
    return {
      visitedTabMap,
      hasTabBeenVisited,
      handleVisitTab,
    };
  }, [visitedTabMap, hasTabBeenVisited, handleVisitTab]);

  return (
    <CustomLayoutContext.Provider value={memoizedValue}>
      {children}
    </CustomLayoutContext.Provider>
  );
};

// Use CustomLayout State Context
const useCustomLayoutContext = () => {
  const context = React.useContext(CustomLayoutContext);
  if (context === undefined) {
    throw new Error('useBalanceTransferContext must be used within a BalanceTransferProvider');
  }
  return context;
};

export const useHandleVisitTab = (tabName) => {
  const { handleVisitTab } = useCustomLayoutContext();

  React.useEffect(() => {
    handleVisitTab(tabName);
  }, [tabName]);
};


CustomLayoutProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};

export {
  CustomLayoutProvider,
  useCustomLayoutContext,
};
